import React, { useEffect, useState } from 'react';
import T from 'i18n';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { selectParams, selectPermissions } from 'common/selectors';
import { useForm } from 'react-hook-form';
import * as actions from '../../redux/actions';
import { Spinner, Table } from 'features/common';
import { Card, Form } from 'react-bootstrap';
import { documentModalActions } from '../../enums';
import equal from 'react-fast-compare';
import { fileVersionsTablecolumnSelector } from '../../DocumentsModal';
import { Modal } from 'features/common/MaterialBasedComponents';

export const FileVersions = ({ show, handleClose, selectedRows }) => {
  const { handleSubmit } = useForm();
  const dispatch = useDispatch();
  const [fileVersions, setFileVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteVersion, setDeleteVersion] = useState(null);
  const { file } = useSelector(selectParams);
  const { documents: { canSeeFileVersions, canRemoveFileVersions } = {} } =
    useSelector(selectPermissions);
  const originalVersionsList = fileVersions.filter((itm) => !itm.type && itm.type !== 'dummy');
  const showDeleteFileVersion = canRemoveFileVersions && originalVersionsList.length > 1;
  const lastVersion = originalVersionsList[originalVersionsList.length - 1];
  const isAdminLevelPermisisons = canSeeFileVersions && canSeeFileVersions(selectedRows[0]);
  const isItemLoaded = ({ index }) => !!fileVersions[index];
  const loadMoreItems = () => {};

  const deleteFileVersion = (versionId) => {
    setLoading(true);
    dispatch(
      actions.deleteFileVersions({
        fileId: selectedRows[0].id || file,
        versions: [{ id: versionId }],
      }),
    )
      .then(() => {
        const filteredFileVersions = fileVersions.filter((itm) => itm.id !== versionId);
        setFileVersions(filteredFileVersions);
      })
      .finally(() => {
        setLoading(false);
        setDeleteVersion(null);
      });
  };

  const createTiffAction = () => {
    dispatch(
      actions.createFileVersion({
        fileId: selectedRows[0].id || file,
        newVersion: { source: 'tiff' },
      }),
    ).then((res) => {
      const filteredTiffList = fileVersions.filter((itm) => !itm.type && itm.type !== 'dummy');
      const newFileVersions = [...filteredTiffList, res];
      setFileVersions(newFileVersions);
    });
  };

  const updateFileVersions = (versionId) => {
    const updatedFileVersions = fileVersions.map((item) => {
      if (item.id === versionId) return { ...item, active: true };
      else return { ...item, active: false };
    });
    if (!equal(fileVersions, updatedFileVersions))
      dispatch(
        actions.updateFileVersions({
          fileId: selectedRows[0].id || file,
          versions: updatedFileVersions,
        }),
      ).then((res) => setFileVersions(res));
  };
  const columns = fileVersionsTablecolumnSelector(
    updateFileVersions,
    createTiffAction,
    isAdminLevelPermisisons,
    documentModalActions.fileVersions,
    setDeleteVersion,
    showDeleteFileVersion,
    lastVersion,
  );

  useEffect(() => {
    dispatch(actions.fetchFileVersions({ fileId: selectedRows[0].id || file }))
      .then((res) => {
        const containsTiff = res.find((itm) => itm.source === 'tiff');
        if (isAdminLevelPermisisons && !containsTiff) setFileVersions([...res, { type: 'dummy' }]);
        else setFileVersions(res);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [show, selectedRows, dispatch, isAdminLevelPermisisons, file]);

  return (
    <>
      <Modal
        show={show}
        title={T.translate('generic.fileVersions') + ` - ${selectedRows[0].id || file}`}
        handleClose={() => {
          if (loading) setLoading(false);
          setFileVersions([]);
          handleClose();
        }}
        saveTitle={deleteVersion ? T.translate('generic.delete') : null}
        handleSave={deleteVersion ? handleSubmit(() => deleteFileVersion(deleteVersion.id)) : null}
        disableSave={loading}
      >
        {!loading &&
          !deleteVersion &&
          (fileVersions && fileVersions.length > 0 ? (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <Form.Group>
                <Card
                  style={{
                    margin: '-1.5rem',
                    height: '25rem',
                  }}
                >
                  <Table
                    key={Math.random()}
                    data={fileVersions}
                    columns={columns}
                    isItemLoaded={isItemLoaded}
                    loadMoreItems={loadMoreItems}
                    totalDocumentsCount={0}
                    rowHeight={50}
                    readOnly
                  />
                </Card>
              </Form.Group>
            </Form>
          ) : (
            T.translate('generic.noFileVersionsFound')
          ))}
        {loading && <Spinner />}
        {!loading && deleteVersion && (
          <span>{T.translate('case.deleteVersionWarning', { source: deleteVersion.source })}</span>
        )}
      </Modal>
    </>
  );
};
